import React from "react";
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import CV from "./pages/CV";
import Blog from "./pages/Blog/Blog";
import Contact from "./pages/Contact";
import BlogPost from "./pages/Blog/BlogPost";
import PostDetailPage from "./pages/Blog/PostDetailPage";
import NotFound from "./pages/NotFound";

const Navbar = () => {
  const location = useLocation();

  const getLinkClass = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + "/")
      ? "text-dracula-green font-bold"
      : "text-dracula-cyan hover:text-dracula-green";
  };

  return (
    <nav aria-label="Main navigation" className="bg-dracula-currentLine p-4 flex justify-center items-center w-full shadow-lg mb-4">
      <Link to="/" className="flex items-center" aria-label="Victor Springer — Home">
        <img
          src="/logo192.png"
          alt="Victor Springer logo"
          width="40"
          height="40"
          decoding="async"
          className="h-10 w-auto mr-4"
        />
      </Link>

      <div className="flex space-x-6">
        <Link to="/" className={getLinkClass("/")} aria-current={location.pathname === "/" ? "page" : undefined}>Home</Link>
        <Link to="/cv" className={getLinkClass("/cv")} aria-current={location.pathname.startsWith("/cv") ? "page" : undefined}>CV</Link>
        <Link to="/blog" className={getLinkClass("/blog")} aria-current={location.pathname.startsWith("/blog") ? "page" : undefined}>Blog</Link>
        <Link to="/contact" className={getLinkClass("/contact")} aria-current={location.pathname.startsWith("/contact") ? "page" : undefined}>Contact</Link>
      </div>
    </nav>
  );
};

const App = () => {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />

        <div className="flex-grow p-6 pt-12 bg-dracula-background text-dracula-foreground">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<PostDetailPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog-post" element={<BlogPost />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>

        <footer className="max-w-4xl mx-auto mt-4 text-center border-t border-dracula-comment p-8 flex-shrink-0">
          <p className="text-sm">© {new Date().getFullYear()} Victor Springer. All Rights Reserved.</p>
        </footer>
      </div>
    </Router>
  );
};

export default App;
